import { isAxiosError } from 'axios'
import { getErrorMessage } from '../../helpers/errors.helper'

export type ApiErrorReason =
  | 'networkError'
  | 'clientError' // 4xx
  | 'serverError' // 5xx
  | 'timeout'
  | 'unauthorized'
  | 'forbidden'
  | 'notFound'
  | 'payloadTooLarge'
  | 'unknown'

export type ApiError = {
  reason: ApiErrorReason
  traceId?: string | null
  status?: number
  message?: string
  _error: unknown
}

export function parseApiError(error: unknown): ApiError {
  if (!isAxiosError(error)) {
    return {
      traceId: null,
      reason: 'unknown',
      _error: error,
    }
  }

  const status = error.response?.status
  if (!status) {
    return { reason: 'networkError', _error: error }
  }

  const traceId = error.response?.headers['x-trace-id'] ?? null
  const message = error.response?.data?.message ?? getErrorMessage(error)

  if (status === 401) {
    // tsentraliseeritud errori halduse lisamisel vaja lisada header WWW-Authenticate haldus
    return {
      traceId, reason: 'unauthorized', status, message, _error: error,
    }
  }
  if (status === 403) {
    return {
      traceId, reason: 'forbidden', status, message, _error: error,
    }
  }
  if (status === 404) {
    return {
      traceId, reason: 'notFound', status, message, _error: error,
    }
  }
  if (status === 413) {
    return {
      traceId, reason: 'payloadTooLarge', status, message, _error: error,
    }
  }
  if (status >= 500) {
    return {
      traceId, reason: 'serverError', status, message, _error: error,
    }
  }
  if (status >= 400) {
    return {
      traceId, reason: 'clientError', status, message, _error: error,
    }
  }

  return {
    traceId, reason: 'unknown', status, _error: error,
  }
}

